webpackJsonp([76],{

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportCustomer_vue__ = __webpack_require__(688);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3109f72a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportCustomer_vue__ = __webpack_require__(859);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3109f72a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 688:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_shop_report_customerReportService_js__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_master_company_companyService_js__ = __webpack_require__(489);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToExport: function isAllowToExport() {
      return this.allPermissions.includes("Export");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    }
  },
  data: function data() {
    return {
      validationErrors: {
        paymentStatus: null,
        progressType: null,
        sortby: null,
        filter: null
      },
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      exportParam: {
        reservationRange: null,
        paymentStatus: null,
        progressType: null,
        sortBy: null,
        isAsc: null,
        filterType: null,
        bookers: [],
        passengers: []
      },
      filters: [],
      companies: [],
      paymentStatus: [],
      progressTypes: [],
      sortBy: [],
      rentalLabel: null,
      airportLabel: null,
      allPermissions: [],
      items: [],
      // period: "daily",
      period: "all",
      isLoading: false,
      msg: "Please wait"
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);
              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);
              _this.rentalLabel = _this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");
              _this.airportLabel = _this.$helper.extractSetting(publicSettings, "AirportLabel", "Airport");

              _context.next = 10;
              return _this.$store.dispatch("user/getProfile");

            case 10:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 21;
                break;
              }

              _this.paymentStatus = [{ value: "All", text: "All" }, { value: "Complete", text: "Completed" }, { value: "Unpaid", text: "Unpaid" }, { value: "RefundRequested", text: "Refund Requested" }, { value: "Refunded", text: "Refunded" }, { value: "RefundRejected", text: "Refund Rejected" }];

              _this.progressTypes = [{ value: "All", text: "All" }, { value: "Open", text: "Open" }, { value: "Run", text: "Run" }, { value: "Done", text: "Done" }, { value: "Close", text: "Close" }, { value: "Abort", text: "Abort" }, { value: "RescueOperation", text: "Rescue" }];

              _this.sortBy = [{ value: "ReservationDate", text: "Reservation Date" }, { value: "PickUpDate", text: "Pick-Up Date" }, { value: "DropOffDate", text: "Drop-Off Date" }];

              _this.filters = [{ value: "None", text: "None" }, { value: "Booker", text: "Booker" }, { value: "Passenger", text: "Passenger" }];

              _this.getCompanies();
              _context.next = 21;
              return _this.getAll(_this.period);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("booking-history");
    this.$helper.setNavigationClass("customer-report-link");
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll(_this2.period);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll(_this3.period);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll(_this4.period);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _this5.companies = _context6.sent;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    getAll: function getAll(period) {
      var _this6 = this;

      var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this6.isAllowToRead) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.prev = 2;

                if (clear) _this6.table.pageNumber = 1;
                _this6.isLoading = true;
                _this6.period = period;
                filter = "?page=" + _this6.table.pageNumber + "&size=" + _this6.table.pageSize;

                if (_this6.table.keyword !== null && _this6.table.keyword !== "") {
                  filter += "&search=" + _this6.table.keyword;
                }
                filter += "&data=" + _this6.period + ";";
                _context7.next = 11;
                return __WEBPACK_IMPORTED_MODULE_2__services_shop_report_customerReportService_js__["a" /* default */].getAll(filter);

              case 11:
                response = _context7.sent;

                if (!(response.data == null)) {
                  _context7.next = 18;
                  break;
                }

                _this6.$notification.error("No reservation found", { title: "Error" });
                _this6.items = [];
                _this6.table.totalPages = 1;
                _this6.table.totalRecords = response.totalRecords;
                return _context7.abrupt("return");

              case 18:
                _this6.items = response.data.items;
                _this6.table.totalPages = response.totalPages;
                _this6.table.totalRecords = response.totalRecords;
                _context7.next = 26;
                break;

              case 23:
                _context7.prev = 23;
                _context7.t0 = _context7["catch"](2);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this6.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }

              case 26:
                _context7.prev = 26;

                _this6.isLoading = false;
                return _context7.finish(26);

              case 29:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6, [[2, 23, 26, 29]]);
      }))();
    },
    open: function open(reservation) {
      var pathUrl = reservation.isInquiry ? "/reservation/inquiry/" : "/reservation/instant/";
      var routeData = this.$router.resolve({
        path: pathUrl + reservation.id
      });
      window.open(routeData.href, "_blank");
    },
    openExportModal: function openExportModal() {
      var thisMonth = new Date();
      var selectedDate = thisMonth.getFullYear() + "-" + (thisMonth.getMonth() + 1) + "-" + thisMonth.getDate();
      this.exportParam.reservationRange = {
        start: selectedDate,
        end: selectedDate
      };
      this.exportParam.progressType = "All";
      this.exportParam.paymentStatus = "All";
      this.exportParam.sortBy = "ReservationDate";
      this.exportParam.isAsc = true;
      this.exportParam.filterType = "None";
      this.exportParam.bookers = [];
      this.exportParam.passengers = [];
      $(this.$refs.exportmodal).modal({ backdrop: "static", keyboard: false });
    },
    exportToExcel: function exportToExcel() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var startDates, endDates, request, response, link, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this7.isLoading = true;
                startDates = _this7.exportParam.reservationRange.start.split("-");
                endDates = _this7.exportParam.reservationRange.end.split("-");
                request = {
                  filterType: _this7.exportParam.filterType,
                  filterIds: [],
                  startDate: {
                    year: startDates[0],
                    month: startDates[1],
                    day: startDates[2]
                  },
                  endDate: { year: endDates[0], month: endDates[1], day: endDates[2] },
                  paymentStatus: _this7.exportParam.paymentStatus,
                  progressType: _this7.exportParam.progressType,
                  sortBy: _this7.exportParam.sortBy,
                  isAsc: _this7.exportParam.isAsc
                };
                _context8.t0 = request.filterType;
                _context8.next = _context8.t0 === "Booker" ? 8 : _context8.t0 === "Passenger" ? 10 : 12;
                break;

              case 8:
                request.filterIds = _this7.exportParam.bookers.map(function (x) {
                  return x.id;
                });
                return _context8.abrupt("break", 12);

              case 10:
                request.filterIds = _this7.exportParam.passengers.map(function (x) {
                  return x.id;
                });
                return _context8.abrupt("break", 12);

              case 12:
                _context8.next = 14;
                return __WEBPACK_IMPORTED_MODULE_2__services_shop_report_customerReportService_js__["a" /* default */].exportToExcel(request);

              case 14:
                response = _context8.sent;

                if (response.data.isReportExist) {
                  link = document.createElement("a");

                  link.href = "data:application/octet-stream;charset=utf-8;base64," + response.data.content;
                  link.target = "_blank";
                  link.download = response.data.name + ".xlsx";
                  link.click();
                } else {
                  _this7.$notification.warning("Report not found", { title: "Warning" });
                }
                _context8.next = 21;
                break;

              case 18:
                _context8.prev = 18;
                _context8.t1 = _context8["catch"](0);

                if (_context8.t1.errors) {
                  for (index = 0; index < _context8.t1.errors.length; index++) {
                    _this7.$notification.error(_context8.t1.errors[index], { title: "Error" });
                  }
                }

              case 21:
                _context8.prev = 21;

                _this7.isLoading = false;
                return _context8.finish(21);

              case 24:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[0, 18, 21, 24]]);
      }))();
    },
    formatDate: function formatDate(datetime) {
      return datetime.stringShortMonth + ", " + datetime.stringDate + " " + datetime.year;
    },
    formatTime: function formatTime(datetime) {
      return datetime.stringHour + ":" + datetime.stringMinute;
    },
    isAirportTransfer: function isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    }
  }
});

/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/shop/reports/customer';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  exportToExcel: function exportToExcel(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/export/xls', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row mt-20"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToExport)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.openExportModal()}}},[_vm._m(0),_vm._v("Export\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  "+_vm._s(_vm.rentalLabel)+" & "+_vm._s(_vm.airportLabel)+" Bookings\n                  "),_vm._m(1)]),_vm._v(" "),_c('p',[_vm._v("Manage and view all transactions.")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 text-right"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"..."}},[_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'all' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('all')}}},[_vm._v("\n                All\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'daily' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('daily', true)}}},[_vm._v("\n                Daily\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'weekly' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('weekly', true)}}},[_vm._v("\n                Weekly\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'monthly' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('monthly', true)}}},[_vm._v("\n                Monthly\n              ")])])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Reservation Code"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                          _vm.isAirportTransfer(item.serviceType) &&
                          item.pickUpLocation.isAirport
                        )?_c('i',{staticClass:"ic-flight-icon"}):(
                          _vm.isAirportTransfer(item.serviceType) &&
                          item.dropOffLocation.isAirport
                        )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                          _vm.isAirportTransfer(item.serviceType) &&
                          !item.pickUpLocation.isAirport &&
                          !item.dropOffLocation.isAirport
                        )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"view-detail-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.open(item)}}},[_vm._v("\n                      "+_vm._s(item.code)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.booker.companyName))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                      "+_vm._s(item.booker.customerTitle)+".\n                      "+_vm._s(item.booker.customerName)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.passenger.companyName))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                      "+_vm._s(item.passenger.customerTitle)+".\n                      "+_vm._s(item.passenger.customerName)+"\n                    ")])]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(item.className)+"\n                    "),(item.vehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                        "+_vm._s(item.vehicle.factoryName)+"\n                        "+_vm._s(item.vehicle.brandName)+"\n                      ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                        ("+_vm._s(item.vehicle.plateNumber)+")\n                      ")])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.formatDate(item.pickUpDate))+"\n                    "),_c('strong',[_vm._v(_vm._s(_vm.formatTime(item.pickUpDate)))]),_vm._v(" "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.formatDate(item.dropOffDate))+"\n                    "),_c('strong',[_vm._v(_vm._s(_vm.formatTime(item.dropOffDate)))]),_vm._v(" "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('td',{class:{
                      '--green35':
                        item.paymentStatus === 'Complete' ||
                        item.paymentStatus === 'Refunded',
                      'sts-danger':
                        item.paymentStatus === 'Unpaid' ||
                        item.paymentStatus === 'RefundRequested',
                    }},[_vm._v("\n                    "+_vm._s(item.paymentStatus === "Complete"
                        ? "Completed"
                        : _vm.humanize(item.paymentStatus))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{class:{
                        'sts_job-open': item.progress === 'Open',
                        'sts_job-run': item.progress === 'Run',
                        'sts_job-done': item.progress === 'Done',
                        'sts_job-closed': item.progress === 'Close',
                        'sts_job-aborted': item.progress === 'Abort',
                        'sts_job-rescue_operation':
                          item.progress === 'RescueOperation',
                        'sts_job-under-review':
                          item.progress === 'UnderReview',
                      }})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(item.sellingRate.currencyCode)+"\n                    "+_vm._s(_vm.$currencyFormat(
                        item.sellingRate.currencyCode,
                        item.sellingRate.grandTotal
                      ))+"\n                  ")])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"exportmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('form',{attrs:{"action":"#","id":"vueform","role":"form"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Reservation Range")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"mutation-start","color":"#025BC5","format":"YYYY-MM-DD","formatted":"LL","range":"","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.exportParam.reservationRange),callback:function ($$v) {_vm.$set(_vm.exportParam, "reservationRange", $$v)},expression:"exportParam.reservationRange"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Payment Status")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.paymentStatus,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                      var attributes = ref.attributes;
                      var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"paymentStatus","required":!_vm.exportParam.paymentStatus}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.paymentStatus),callback:function ($$v) {_vm.$set(_vm.exportParam, "paymentStatus", $$v)},expression:"exportParam.paymentStatus"}}),_vm._v(" "),(_vm.validationErrors.paymentStatus)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.paymentStatus)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Progress Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.progressTypes,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                      var attributes = ref.attributes;
                      var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"progressType","required":!_vm.exportParam.progressType}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.progressType),callback:function ($$v) {_vm.$set(_vm.exportParam, "progressType", $$v)},expression:"exportParam.progressType"}}),_vm._v(" "),(_vm.validationErrors.progressType)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.progressType)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Sort")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.sortBy,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                      var attributes = ref.attributes;
                      var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"sortBy","required":!_vm.exportParam.sortBy}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.sortBy),callback:function ($$v) {_vm.$set(_vm.exportParam, "sortBy", $$v)},expression:"exportParam.sortBy"}}),_vm._v(" "),(_vm.validationErrors.sortBy)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.sortBy)}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-flex"},[_c('label',{staticClass:"cursor-pointer mb-0 mt-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exportParam.isAsc),expression:"exportParam.isAsc"}],staticClass:"control-radio",attrs:{"type":"radio","value":"true"},domProps:{"checked":_vm.exportParam.isAsc == true,"checked":_vm._q(_vm.exportParam.isAsc,"true")},on:{"change":function($event){return _vm.$set(_vm.exportParam, "isAsc", "true")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Oldest")])]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer mb-0 mt-5 pl-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exportParam.isAsc),expression:"exportParam.isAsc"}],staticClass:"control-radio",attrs:{"type":"radio","value":"false"},domProps:{"checked":_vm.exportParam.isAsc == false,"checked":_vm._q(_vm.exportParam.isAsc,"false")},on:{"change":function($event){return _vm.$set(_vm.exportParam, "isAsc", "false")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Newest")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Filter")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.filters,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.exportParam.filterType),callback:function ($$v) {_vm.$set(_vm.exportParam, "filterType", $$v)},expression:"exportParam.filterType"}})],1),_vm._v(" "),(_vm.exportParam.filterType === 'Booker')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company's "+_vm._s(_vm.exportParam.filterType))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.companies,"multiple":true,"close-on-select":false,"limit":1,"placeholder":"Select booker","label":"name","track-by":"id"},model:{value:(_vm.exportParam.bookers),callback:function ($$v) {_vm.$set(_vm.exportParam, "bookers", $$v)},expression:"exportParam.bookers"}})],1):_vm._e(),_vm._v(" "),(_vm.exportParam.filterType === 'Passenger')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company's "+_vm._s(_vm.exportParam.filterType))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.companies,"multiple":true,"close-on-select":false,"limit":1,"placeholder":"Select passenger","label":"name","track-by":"id"},model:{value:(_vm.exportParam.passengers),callback:function ($$v) {_vm.$set(_vm.exportParam, "passengers", $$v)},expression:"exportParam.passengers"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.exportToExcel()}}},[_vm._v("\n                      Export\n                    ")])])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"ic-download"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"ic-booking-history"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code")]),_vm._v(" "),_c('th',[_vm._v("Booker")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',[_vm._v("Drop-Off")]),_vm._v(" "),_c('th',[_vm._v("Payment")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Progress")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Export Report")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/76.c7298bc8bc35ad5c2626.js